import { api } from "../lib/api";
import type { GetReadyTasksResponse } from "../types/task";

/**
 * Get the Get Ready tasks feed for the current user.
 */
export async function getGetReadyTasks(): Promise<GetReadyTasksResponse> {
	const response = await api.get<GetReadyTasksResponse>("/api/tasks");
	return response.data;
}
